module.exports = __webpack_public_path__ + "55d44bd5f4dfa1f3d23cc7a072798185.png";